// @flow
import type {SearchParamsType} from '../reducers/searchParams';
import {
    INSTANT_BOOK_FILTER_ID,
    LEGACY_INSTANT_BOOK_ID,
    INSTANT_BOOK_SLOT_VALUE
} from '../constants/filters';

export const newArrayFromFilters = (values: SearchParamsType): string[] => {
    const newArray = (values.filter && [].concat(values.filter)) || [];
    newArray.sort();
    return newArray;
};

export const instantBookFilter = (filter: any): string | null => {
    const filtered = []
        .concat(filter || [])
        .map((f) => f.toLowerCase().trim())
        .filter(
            (f) =>
                INSTANT_BOOK_FILTER_ID === f ||
                LEGACY_INSTANT_BOOK_ID === f ||
                f.includes(INSTANT_BOOK_SLOT_VALUE)
        );
    return filtered.length ? filtered[0] : null;
};

export const isOnlyInstantConfirmationFilter = (filters: string[]) => {
    return filters.length === 1 && !!instantBookFilter(filters);
};

export const isFilterSelected = (
    filters: string[],
    expectedFilter: ?string
): boolean => {
    if (filters) {
        return filters.includes(expectedFilter);
    }
    return false;
};

export const parseFilterName = (filterId: ?string): ?string => {
    if (filterId) {
        return `filter:${filterId}`;
    }
    return null;
};
